import { ListItem, ListItemText } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import React from 'react';

import Img from 'retired/Img';
import CheckCircleIcon from 'assets/icons/check-circle.svg';
import { lightGray } from 'utils/color-styles';
import { Privileges } from 'utils/privileges';
import NonprofitLink from 'retired/NonprofitLink';
import User from 'entities/user/model';
import Organization from 'entities/organization/model';

interface SelectedNonprofitProps {
  nonprofit: Organization;
  input: object;
  user: User;
}

export const SelectedNonprofit = ({
  input: { onChange },
  nonprofit,
  user,
}: SelectedNonprofitProps): JSX.Element => (
  <ListItem
    style={{
      border: '1px solid',
      marginTop: 15,
      marginBottom: 25,
      width: '100%',
      borderColor: lightGray,
    }}
  >
    {' '}
    <IconButton size="small" onClick={() => onChange(null)} title="Remove nonprofit">
      <ClearIcon size="small" />
    </IconButton>
    <ListItemText
      primary={
        <>
          {user?.hasPrivilege(Privileges.PARTNER_VIEW) ? (
            <NonprofitLink nonprofit={nonprofit} />
          ) : (
            <>{nonprofit.name}</>
          )}{' '}
          {nonprofit.ein ? <>– EIN: {nonprofit.ein}</> : null}
          {nonprofit.approved && (
            <Img
              src={CheckCircleIcon}
              style={{ width: '20px', marginLeft: 6 }}
              alt="Approved"
              title="Approved"
            />
          )}
        </>
      }
      secondary={
        <>
          {nonprofit.locationObject?.city
            ? [
                nonprofit.locationObject?.address,
                nonprofit.locationObject?.city,
                nonprofit.locationObject?.state &&
                  nonprofit.locationObject?.postalCode &&
                  `${nonprofit.locationObject?.state} ${nonprofit.locationObject?.postalCode}`,
              ]
                .filter(Boolean)
                .join(', ')
            : ''}
          {nonprofit.state}
        </>
      }
    />
  </ListItem>
);
